/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_Quaint_Liger_LoveInputs */

const fr_free_quaint_liger_love = /** @type {(inputs: Free_Quaint_Liger_LoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**

* @param {Free_Quaint_Liger_LoveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const free_quaint_liger_love = /** @type {((inputs?: Free_Quaint_Liger_LoveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_Quaint_Liger_LoveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_free_quaint_liger_love(inputs)
});